module.exports = __webpack_public_path__ + "static/media/mistral.da77897b.svg";